export const resumeSamples = [
    {
      title: 'Software Engineering Resume',
      targetRole: 'Backend / Full Stack / SDE Roles',
      link: 'https://drive.google.com/file/d/1OQLb-7dB0adOdAxxHdzRyS36DZQy-T1t/view?usp=sharing',
      accent: 'from-indigo-500 to-blue-500',
    },
    {
      title: 'Web Developer Resume',
      targetRole: 'Frontend / Full Stack Web Roles',
      link: 'https://drive.google.com/file/d/1-HqLYq9Wb6kKhcl3eWEyfi3a3ksoeeMt/view?usp=sharing',
      accent: 'from-cyan-500 to-sky-500',
    },
    {
      title: 'Fresher Resume',
      targetRole: 'Campus Placement Entry Roles',
      link: 'https://drive.google.com/file/d/1QYO8VvBI31FdM5axwkl686mzaZHzBW_a/view?usp=sharing',
      accent: 'from-violet-500 to-purple-500',
    },
    {
      title: 'HR Resume',
      targetRole: 'Human Resources Profiles',
      link: 'https://drive.google.com/file/d/1It0StiU7h6WcVZnpFTiX4gQ4Gu1m80XU/view?usp=sharing',
      accent: 'from-fuchsia-500 to-rose-500',
    },
    {
      title: 'Intern Resume',
      targetRole: 'Summer / Semester Internship Roles',
      link: 'https://drive.google.com/file/d/1IZlTCk-nYxFfduNcyUkUfWc_yx6tk-ST/view?usp=sharing',
      accent: 'from-emerald-500 to-teal-500',
    },
  ];
